import { c as _c } from "react/compiler-runtime";
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BrowserOnly from 'components/consumer/BrowserOnly';
import RatioContainer from 'components/consumer/RatioContainer';
import JBProductImage from 'components/essentials/JBImage/JBProductImage';
import JBImage from 'components/essentials/JBImage';
import PDPDesktopFullScreenGallery2 from 'components/consumer/PDP/PDPDesktopFullScreenGallery2';
import PDPGalleryLabelsAndViewingCount from 'components/consumer/PDP/PDPGalleryLabelsAndViewingCount';
import PDPDecideLaterOverlay from 'components/consumer/PDP/PDPDecideLaterOverlay';
import PDPCylindo3dViewer from 'components/consumer/PDP/PDPCylindo3dViewer';
import Placeholder from 'components/consumer/Placeholder';
import PDPFavoriteButton from 'components/consumer/PDPFavoriteButton';
import { markLuxPageNavigationEnd } from 'commons/lux';
import useScreen from 'hooks/useScreen';
import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';
import BarbieLogo from 'assets/images/made-for-barbie-logo.png';
import BipocLogo from 'assets/images/bipoc-badge.png';
import useIsBrowser from 'hooks/useIsBrowser';
import useBrokenImageUrls from 'global-state/brokenImageUrls/useBrokenImageUrls';
import PDPDesktopThumbnails from './PDPDesktopThumbnails';
import { getMainImageImgixPropsForPhoto } from './helpers/imgix-props';
import usePDPDesktopHeroSizeProps from './helpers/usePDPDesktopHeroSizeProps';
import PDPProductIntroVideo from './PDPProductIntroVideo';
import { PDP_MAIN_IMAGE } from './specs/testIds';
import LinkOrFragment from '../../LinkOrFragment';
import PDPDimensionShotViewer from '../PDPDimensionShotViewer';
const QUICKVIEW_GALLERY_TABLET_IMAGE_WIDTH = '100%';
const QUICKVIEW_GALLERY_MAX_IMAGE_WIDTH = 570;
const dazeyLogo = 'https://joybird2.imgix.net/user-uploads-staging/JBxDaniDazey-Logo-Button.png';
const PDPDesktopHeroGalleryUI = t0 => {
  const $ = _c(153);
  const {
    campaign,
    configurationPhotos: t1,
    cylindoFeatures,
    dimensionsImage,
    enableCrops: t2,
    introVideoIds,
    isConfigFlipped: t3,
    isCylindoAvailable,
    isCylindoConfigurationPhotos,
    isEditOrder: t4,
    isVideoSelected,
    loading: t5,
    mainPhotoLink,
    mode: t6,
    pdpIsModularBYOProduct: t7,
    productName,
    selectedPhoto,
    setIsVideoSelected,
    setSelectedPhoto,
    showDecideLaterOverlay,
    studioPhotos: t8,
    viewGalleryImageEvent,
    dimensionShotUrls: t9,
    currentDimensionShot,
    hasMultipleDimensionShots: t10,
    selectedDimensionShotIndex: t11,
    goToNextDimensionShot,
    goToPreviousDimensionShot,
    shouldShowDimensionThumbnail: t12
  } = t0;
  let t13;
  if ($[0] !== t1) {
    t13 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t13;
  } else {
    t13 = $[1];
  }
  const configurationPhotos = t13;
  const enableCrops = t2 === undefined ? true : t2;
  const isConfigFlipped = t3 === undefined ? false : t3;
  const isEditOrder = t4 === undefined ? true : t4;
  const loading = t5 === undefined ? false : t5;
  const mode = t6 === undefined ? "pdp" : t6;
  const pdpIsModularBYOProduct = t7 === undefined ? false : t7;
  let t14;
  if ($[2] !== t8) {
    t14 = t8 === undefined ? [] : t8;
    $[2] = t8;
    $[3] = t14;
  } else {
    t14 = $[3];
  }
  const studioPhotos = t14;
  let t15;
  if ($[4] !== t9) {
    t15 = t9 === undefined ? [] : t9;
    $[4] = t9;
    $[5] = t15;
  } else {
    t15 = $[5];
  }
  const dimensionShotUrls = t15;
  const hasMultipleDimensionShots = t10 === undefined ? false : t10;
  const selectedDimensionShotIndex = t11 === undefined ? 0 : t11;
  const shouldShowDimensionThumbnail = t12 === undefined ? false : t12;
  const {
    isMobile,
    isMobileOrTablet,
    isDesktop
  } = useScreen();
  const isQuickviewMode = mode === "quickview";
  const isPdpMode = mode === "pdp";
  const isBrowser = useIsBrowser();
  const [isFullScreenGalleryOpen, setIsFullScreenGalleryOpen] = useState(false);
  const brokenImageUrls = useBrokenImageUrls();
  const isStudioGallery = selectedPhoto?.type === "studio";
  const isDimensionImg = selectedPhoto?.type === "dimensional";
  const isConfigGallery = selectedPhoto?.type === "configuration" || selectedPhoto?.type === "cylindo";
  const isBuildYourOwnImg = selectedPhoto?.type === "buildyourown";
  let t16;
  if ($[6] !== configurationPhotos || $[7] !== isBuildYourOwnImg || $[8] !== isStudioGallery || $[9] !== pdpIsModularBYOProduct || $[10] !== selectedPhoto || $[11] !== studioPhotos) {
    t16 = isStudioGallery ? studioPhotos : pdpIsModularBYOProduct && isBuildYourOwnImg ? [selectedPhoto] : configurationPhotos;
    $[6] = configurationPhotos;
    $[7] = isBuildYourOwnImg;
    $[8] = isStudioGallery;
    $[9] = pdpIsModularBYOProduct;
    $[10] = selectedPhoto;
    $[11] = studioPhotos;
    $[12] = t16;
  } else {
    t16 = $[12];
  }
  const allPhotos = t16;
  let t17;
  if ($[13] !== allPhotos || $[14] !== brokenImageUrls) {
    let t18;
    if ($[16] !== brokenImageUrls) {
      t18 = t19 => {
        const {
          src
        } = t19;
        const cleanImageUrl = getImageUrlWithoutQuery(src);
        return !brokenImageUrls.includes(cleanImageUrl);
      };
      $[16] = brokenImageUrls;
      $[17] = t18;
    } else {
      t18 = $[17];
    }
    t17 = allPhotos.filter(t18);
    $[13] = allPhotos;
    $[14] = brokenImageUrls;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  const validPhotos = t17;
  const photos = validPhotos;
  let t18;
  if ($[18] !== photos || $[19] !== selectedPhoto?.src) {
    let t19;
    if ($[21] !== selectedPhoto?.src) {
      t19 = t20 => {
        const {
          src: src_0
        } = t20;
        return src_0 === selectedPhoto?.src;
      };
      $[21] = selectedPhoto?.src;
      $[22] = t19;
    } else {
      t19 = $[22];
    }
    t18 = photos.findIndex(t19);
    $[18] = photos;
    $[19] = selectedPhoto?.src;
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  const selectedPhotoIndex = Math.max(0, t18);
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  const introVideoId = introVideoIds && (isMobile ? introVideoIds.mobile : introVideoIds.desktop);
  const ratioForCroppedImages = isMobileOrTablet ? 1 : 0.6666666666666666;
  const ratio = loading || enableCrops ? ratioForCroppedImages : 0.5;
  const spaceAround = 194;
  let t19;
  bb0: {
    if (isQuickviewMode) {
      t19 = QUICKVIEW_GALLERY_MAX_IMAGE_WIDTH;
      break bb0;
    }
    t19 = `calc((100vh - ${194}px) / ${ratio})`;
  }
  const maxGalleryWidth = t19;
  let t20;
  bb1: {
    if (isQuickviewMode && !isDesktop) {
      t20 = QUICKVIEW_GALLERY_TABLET_IMAGE_WIDTH;
      break bb1;
    }
    if (isQuickviewMode) {
      t20 = QUICKVIEW_GALLERY_MAX_IMAGE_WIDTH;
      break bb1;
    }
    t20 = undefined;
  }
  const galleryWidth = t20;
  let t21;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = () => {
      setIsFullScreenGalleryOpen(true);
    };
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  const openGalleryModal = t21;
  let t22;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => {
      setIsFullScreenGalleryOpen(false);
    };
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  const closeGalleryModal = t22;
  const isMainPhotoLinked = isQuickviewMode && mainPhotoLink;
  let t23;
  if ($[25] !== galleryWidth || $[26] !== maxGalleryWidth) {
    t23 = {
      maxWidth: maxGalleryWidth,
      width: galleryWidth
    };
    $[25] = galleryWidth;
    $[26] = maxGalleryWidth;
    $[27] = t23;
  } else {
    t23 = $[27];
  }
  const t24 = isMainPhotoLinked ? "block focus-visible:outline-offset-4" : undefined;
  const t25 = isMainPhotoLinked ? mainPhotoLink : undefined;
  const t26 = mode === "pdp";
  const t27 = mode === "quickview";
  let t28;
  if ($[28] !== brokenImageUrls || $[29] !== selectedPhoto?.src || $[30] !== t26 || $[31] !== t27) {
    t28 = classnames("bg-transparent border-0 focus:outline-0", {
      "PDPDesktopHeroGalleryUI__MainPhoto--mode-pdp": t26,
      "PDPDesktopHeroGalleryUI__MainPhoto--mode-quickview": t27,
      "flex justify-center": brokenImageUrls.includes(selectedPhoto?.src)
    });
    $[28] = brokenImageUrls;
    $[29] = selectedPhoto?.src;
    $[30] = t26;
    $[31] = t27;
    $[32] = t28;
  } else {
    t28 = $[32];
  }
  let t29;
  if ($[33] !== isConfigGallery || $[34] !== isCylindoConfigurationPhotos || $[35] !== isPdpMode || $[36] !== isStudioGallery || $[37] !== isVideoSelected) {
    t29 = () => {
      if (isPdpMode && (!isCylindoConfigurationPhotos && isConfigGallery || isStudioGallery) && !isVideoSelected) {
        openGalleryModal();
      }
    };
    $[33] = isConfigGallery;
    $[34] = isCylindoConfigurationPhotos;
    $[35] = isPdpMode;
    $[36] = isStudioGallery;
    $[37] = isVideoSelected;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] !== currentDimensionShot || $[40] !== dimensionShotUrls || $[41] !== enableCrops || $[42] !== goToNextDimensionShot || $[43] !== goToPreviousDimensionShot || $[44] !== hasMultipleDimensionShots || $[45] !== isConfigFlipped || $[46] !== isCylindoAvailable || $[47] !== isCylindoConfigurationPhotos || $[48] !== isDimensionImg || $[49] !== isStudioGallery || $[50] !== isVideoSelected || $[51] !== loading || $[52] !== mainPhotoSizeProps || $[53] !== mode || $[54] !== selectedDimensionShotIndex || $[55] !== selectedPhoto) {
    t30 = !loading && (isCylindoAvailable && isCylindoConfigurationPhotos ? isStudioGallery || isDimensionImg : true) && !isVideoSelected && !!selectedPhoto && (!!selectedPhoto.src || isDimensionImg) && (isDimensionImg ? <PDPDimensionShotViewer currentDimensionShot={currentDimensionShot} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} totalDimensionShots={dimensionShotUrls.length} onPrevious={goToPreviousDimensionShot} onNext={goToNextDimensionShot} className="h-full w-full" {...getMainImageImgixPropsForPhoto(selectedPhoto, enableCrops)} {...mainPhotoSizeProps} data-testid={PDP_MAIN_IMAGE} lazy={false} priority={true} onLoad={markLuxPageNavigationEnd} /> : <JBProductImage className={classnames("h-full w-full object-contain object-center select-none", {
      "p-8": !isStudioGallery && !enableCrops,
      "scale-x-[-1]": !isStudioGallery && isConfigFlipped && !isDimensionImg,
      "hover:cursor-[unset]": !isStudioGallery && isCylindoConfigurationPhotos,
      "hover:cursor-zoom-in": mode === "pdp"
    })} {...getMainImageImgixPropsForPhoto(selectedPhoto, enableCrops)} {...mainPhotoSizeProps} data-testid={PDP_MAIN_IMAGE} lazy={false} priority={true} onLoad={markLuxPageNavigationEnd} />);
    $[39] = currentDimensionShot;
    $[40] = dimensionShotUrls;
    $[41] = enableCrops;
    $[42] = goToNextDimensionShot;
    $[43] = goToPreviousDimensionShot;
    $[44] = hasMultipleDimensionShots;
    $[45] = isConfigFlipped;
    $[46] = isCylindoAvailable;
    $[47] = isCylindoConfigurationPhotos;
    $[48] = isDimensionImg;
    $[49] = isStudioGallery;
    $[50] = isVideoSelected;
    $[51] = loading;
    $[52] = mainPhotoSizeProps;
    $[53] = mode;
    $[54] = selectedDimensionShotIndex;
    $[55] = selectedPhoto;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== introVideoId || $[58] !== isVideoSelected || $[59] !== loading) {
    t31 = !loading && isVideoSelected && introVideoId && <PDPProductIntroVideo videoId={introVideoId} />;
    $[57] = introVideoId;
    $[58] = isVideoSelected;
    $[59] = loading;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== cylindoFeatures || $[62] !== isConfigGallery || $[63] !== isCylindoAvailable || $[64] !== isCylindoConfigurationPhotos || $[65] !== isDimensionImg || $[66] !== isStudioGallery || $[67] !== isVideoSelected || $[68] !== loading || $[69] !== selectedPhotoIndex) {
    t32 = !loading && isCylindoAvailable && <div className={classnames("w-full h-full [&_.mxt-btn-download]:hidden [&_.mxt-btn-expand]:hidden", {
      invisible: !(isCylindoAvailable && isCylindoConfigurationPhotos) || isStudioGallery || isDimensionImg || isVideoSelected
    })}><PDPCylindo3dViewer cylindoFeatures={cylindoFeatures} rotateIndex={isConfigGallery ? selectedPhotoIndex : -1} /></div>;
    $[61] = cylindoFeatures;
    $[62] = isConfigGallery;
    $[63] = isCylindoAvailable;
    $[64] = isCylindoConfigurationPhotos;
    $[65] = isDimensionImg;
    $[66] = isStudioGallery;
    $[67] = isVideoSelected;
    $[68] = loading;
    $[69] = selectedPhotoIndex;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== isStudioGallery || $[72] !== isVideoSelected || $[73] !== loading || $[74] !== showDecideLaterOverlay) {
    t33 = !loading && showDecideLaterOverlay && !(isStudioGallery || isVideoSelected) && <PDPDecideLaterOverlay />;
    $[71] = isStudioGallery;
    $[72] = isVideoSelected;
    $[73] = loading;
    $[74] = showDecideLaterOverlay;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] !== loading) {
    t34 = loading && <Placeholder type="rect" loading={true} />;
    $[76] = loading;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== ratio || $[79] !== t28 || $[80] !== t29 || $[81] !== t30 || $[82] !== t31 || $[83] !== t32 || $[84] !== t33 || $[85] !== t34) {
    t35 = <RatioContainer className={t28} ratio={ratio} onClick={t29}>{t30}{t31}{t32}{t33}{t34}</RatioContainer>;
    $[78] = ratio;
    $[79] = t28;
    $[80] = t29;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
    $[84] = t33;
    $[85] = t34;
    $[86] = t35;
  } else {
    t35 = $[86];
  }
  let t36;
  if ($[87] !== t24 || $[88] !== t25 || $[89] !== t35) {
    t36 = <LinkOrFragment className={t24} to={t25}>{t35}</LinkOrFragment>;
    $[87] = t24;
    $[88] = t25;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  let t37;
  if ($[91] !== isBuildYourOwnImg || $[92] !== isStudioGallery || $[93] !== loading || $[94] !== pdpIsModularBYOProduct) {
    t37 = !loading && pdpIsModularBYOProduct && !isStudioGallery && !isBuildYourOwnImg ? <div className="text-sm font-bold bg-[rgba(44,44,44,.7)] text-white left-[calc(50%_-_85px)] opacity-60 absolute text-center top-[40%] w-[190px] z-[2]">Sample configuration shown</div> : null;
    $[91] = isBuildYourOwnImg;
    $[92] = isStudioGallery;
    $[93] = loading;
    $[94] = pdpIsModularBYOProduct;
    $[95] = t37;
  } else {
    t37 = $[95];
  }
  let t38;
  if ($[96] !== campaign) {
    t38 = campaign === "barbie" && <img src={BarbieLogo} alt="barbie-logo" className="w-20 h-20 absolute top-12 left-4 z-50" />;
    $[96] = campaign;
    $[97] = t38;
  } else {
    t38 = $[97];
  }
  let t39;
  if ($[98] !== campaign) {
    t39 = campaign === "bipoc" && <img src={BipocLogo} alt="bipoc-owned-logo" className="w-20 h-20 absolute top-12 left-4 z-50" />;
    $[98] = campaign;
    $[99] = t39;
  } else {
    t39 = $[99];
  }
  let t40;
  if ($[100] !== campaign) {
    t40 = campaign === "dazey" && <JBImage src={dazeyLogo} className="absolute top-10 left-2 z-50" width={120} />;
    $[100] = campaign;
    $[101] = t40;
  } else {
    t40 = $[101];
  }
  const t41 = loading || !isBrowser;
  let t42;
  if ($[102] !== configurationPhotos || $[103] !== dimensionShotUrls || $[104] !== dimensionsImage || $[105] !== enableCrops || $[106] !== introVideoId || $[107] !== isConfigFlipped || $[108] !== isCylindoConfigurationPhotos || $[109] !== isEditOrder || $[110] !== isVideoSelected || $[111] !== mode || $[112] !== pdpIsModularBYOProduct || $[113] !== productName || $[114] !== selectedPhoto || $[115] !== setIsVideoSelected || $[116] !== setSelectedPhoto || $[117] !== shouldShowDimensionThumbnail || $[118] !== studioPhotos || $[119] !== t41 || $[120] !== viewGalleryImageEvent) {
    t42 = <PDPDesktopThumbnails isEditOrder={isEditOrder} configurationPhotos={configurationPhotos} dimensionsImage={dimensionsImage} shouldShowDimensionThumbnail={shouldShowDimensionThumbnail} dimensionShotUrls={dimensionShotUrls} enableCrops={enableCrops} pdpIsModularBYOProduct={pdpIsModularBYOProduct} introVideoId={introVideoId} isConfigFlipped={isConfigFlipped} isCylindoConfigurationPhotos={isCylindoConfigurationPhotos} isVideoSelected={isVideoSelected} loading={t41} mode={mode} openModal={openGalleryModal} productName={productName} selectedPhoto={selectedPhoto} setSelectedPhoto={setSelectedPhoto} setIsVideoSelected={setIsVideoSelected} studioPhotos={studioPhotos} viewGalleryImageEvent={viewGalleryImageEvent} />;
    $[102] = configurationPhotos;
    $[103] = dimensionShotUrls;
    $[104] = dimensionsImage;
    $[105] = enableCrops;
    $[106] = introVideoId;
    $[107] = isConfigFlipped;
    $[108] = isCylindoConfigurationPhotos;
    $[109] = isEditOrder;
    $[110] = isVideoSelected;
    $[111] = mode;
    $[112] = pdpIsModularBYOProduct;
    $[113] = productName;
    $[114] = selectedPhoto;
    $[115] = setIsVideoSelected;
    $[116] = setSelectedPhoto;
    $[117] = shouldShowDimensionThumbnail;
    $[118] = studioPhotos;
    $[119] = t41;
    $[120] = viewGalleryImageEvent;
    $[121] = t42;
  } else {
    t42 = $[121];
  }
  let t43;
  if ($[122] !== isQuickviewMode || $[123] !== loading || $[124] !== mode) {
    t43 = !loading && <div className="flex justify-between left-4 absolute right-4 top-4 z-[2]"><PDPGalleryLabelsAndViewingCount mode={mode} />{!isQuickviewMode && <PDPFavoriteButton />}</div>;
    $[122] = isQuickviewMode;
    $[123] = loading;
    $[124] = mode;
    $[125] = t43;
  } else {
    t43 = $[125];
  }
  let t44;
  if ($[126] !== t23 || $[127] !== t36 || $[128] !== t37 || $[129] !== t38 || $[130] !== t39 || $[131] !== t40 || $[132] !== t42 || $[133] !== t43) {
    t44 = <div className="mb-8 ml-auto mr-auto relative" style={t23}>{t36}{t37}{t38}{t39}{t40}{t42}{t43}</div>;
    $[126] = t23;
    $[127] = t36;
    $[128] = t37;
    $[129] = t38;
    $[130] = t39;
    $[131] = t40;
    $[132] = t42;
    $[133] = t43;
    $[134] = t44;
  } else {
    t44 = $[134];
  }
  const t45 = productName || "";
  let t46;
  if ($[135] !== t45) {
    t46 = t45.split(" ").join("-");
    $[135] = t45;
    $[136] = t46;
  } else {
    t46 = $[136];
  }
  let t47;
  if ($[137] !== introVideoId || $[138] !== isEditOrder || $[139] !== isFullScreenGalleryOpen || $[140] !== isStudioGallery || $[141] !== isVideoSelected || $[142] !== pdpIsModularBYOProduct || $[143] !== photos || $[144] !== productName || $[145] !== selectedPhotoIndex || $[146] !== setIsVideoSelected || $[147] !== setSelectedPhoto || $[148] !== t46) {
    t47 = <BrowserOnly><PDPDesktopFullScreenGallery2 isEditOrder={isEditOrder} isOpen={isFullScreenGalleryOpen} photos={photos} initialSelectedPhotoIndex={selectedPhotoIndex} onClose={closeGalleryModal} isStudioGallery={isStudioGallery} pdpIsModularBYOProduct={pdpIsModularBYOProduct} productName={productName} key={t46} setSelectedPhoto={setSelectedPhoto} introVideoId={introVideoId} isVideoSelected={isVideoSelected} setIsVideoSelected={setIsVideoSelected} /></BrowserOnly>;
    $[137] = introVideoId;
    $[138] = isEditOrder;
    $[139] = isFullScreenGalleryOpen;
    $[140] = isStudioGallery;
    $[141] = isVideoSelected;
    $[142] = pdpIsModularBYOProduct;
    $[143] = photos;
    $[144] = productName;
    $[145] = selectedPhotoIndex;
    $[146] = setIsVideoSelected;
    $[147] = setSelectedPhoto;
    $[148] = t46;
    $[149] = t47;
  } else {
    t47 = $[149];
  }
  let t48;
  if ($[150] !== t44 || $[151] !== t47) {
    t48 = <>{t44}{t47}</>;
    $[150] = t44;
    $[151] = t47;
    $[152] = t48;
  } else {
    t48 = $[152];
  }
  return t48;
};
PDPDesktopHeroGalleryUI.propTypes = {
  configurationPhotos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'studio'])
  })),
  dimensionsImage: PropTypes.shape({
    id: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }),
  isEditOrder: PropTypes.bool,
  enableCrops: PropTypes.bool,
  loading: PropTypes.bool,
  selectedPhoto: PropTypes.shape({
    type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'studio']),
    src: PropTypes.string
  }),
  setSelectedPhoto: PropTypes.func,
  showDecideLaterOverlay: PropTypes.bool,
  studioPhotos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  isConfigFlipped: PropTypes.bool,
  introVideoIds: PropTypes.shape({
    desktop: PropTypes.string,
    mobile: PropTypes.string
  }),
  setIsVideoSelected: PropTypes.func,
  isVideoSelected: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  productName: PropTypes.string,
  isCylindoAvailable: PropTypes.bool,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  isCylindoConfigurationPhotos: PropTypes.bool,
  viewGalleryImageEvent: PropTypes.func,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  mainPhotoLink: PropTypes.string,
  campaign: PropTypes.string
};
export default PDPDesktopHeroGalleryUI;